<template>
  <div class="item-unit-modal">
    <form action="" @submit.prevent="submitStakeHolderData"> 
      <div class="card-body">
        <div class="form-group row">
            <div class="col-md-6">
              <label class="form-label">{{ $t('profile.stakeholder.name') }}</label><span class="text-danger"> *</span>
              <div v-html="formData.name"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.cnic') }}</label><span class="text-danger"> *</span>
                <div v-html="formData.cnic"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.role') }}</label><span class="text-danger"> *</span>
                <div v-html="formData.role"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.executive_nonexecutive') }}</label><span class="text-danger"> *</span>
                <div v-html="formData.type"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.email') }}</label>
                <div v-html="formData.email"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.address') }}</label>
                <div v-html="formData.address"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_office') }}</label>
                <div v-html="formData.phone_office"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_res') }}</label>
                <div v-html="formData.phone_res"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.phone_cell') }}</label>
                <div v-html="formData.phone_cell"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.fax') }}</label>
                <div v-html="formData.fax"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.national_tax_num') }}</label>
                <div v-html="formData.national_tax"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.share_holding') }}</label>
                <div v-html="formData.share_holding"></div>
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.amount') }}</label>
                <div v-html="$utils.formatMoney(amount, defaultCurrency)" />
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('profile.stakeholder.per_share_holding') }}</label>
                <div v-html="formData.per_share_holding"></div>
            </div>  
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeStakeHolderModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, maxLength, email, url, numeric,minValue,maxValue } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
        formData: {
          id:null,
          name: null,
          address:null,
          email: null,
          cnic:null,
          role:null,
          type:null,
          fax:null,
          national_tax:null,
          share_holding:null,
          per_share_holding:null,
          amount:null,
          phone_office:null,
          phone_cell:null,
          phone_res:null
        },
    }    
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
     ...mapGetters('currency', [
      'defaultCurrency'
    ]),
    amount: {
      get: function () {
        return this.formData.amount / 100
      },
      set: function (newValue) {
        this.formData.amount = newValue * 100
      }
    } 
  },
  created(){
  },
 validations: {
 },
  async mounted () {
    if (this.modalDataID) {
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    resetFormData () {  
      this.formData = {
         id:null,
          name: null,
          address:null,
          email: null,
          cnic:null,
          role:null,
          type:null,
          fax:null,
          national_tax:null,
          share_holding:null,
          per_share_holding:null,
          amount:null,
          phone_office:null,
          phone_cell:null,
          phone_res:null
      }
    },
    
    async setData () {
      this.formData = {
        id: this.modalData.id,
        name: this.modalData.name,
        cnic: this.modalData.cnic,
        role: this.modalData.role,
        type: this.modalData.type,
        address:  this.modalData.address,
        amount: this.modalData.amount,
        phone_office: this.modalData.phone_office,
        phone_res:  this.modalData.phone_res,
        phone_cell: this.modalData.phone_cell,
        email:  this.modalData.email,
        fax:  this.modalData.fax,
        national_tax: this.modalData.national_tax,
        share_holding:  this.modalData.share_holding,
        per_share_holding:  this.modalData.per_share_holding,
      }
    },
    closeStakeHolderModal () {
      this.resetModalData()
      this.resetFormData()
      this.closeModal()
    },
  }
}
</script>
